import React from 'react';
import { Fields, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { renderDate, renderPhone } from '../FormFields';
import { validateReplace } from '../../utils/validation';
import { formatDate, formatPhone } from '../../utils/utils';

const PharmaReplaceForm = props => {
  const { handleSubmit, onSubmit, invalid } = props;
  const sanitizeForm = (values) => {
    const finalForm = {};
    finalForm.mobilePhoneNumber = formatPhone(values.areaCode, values.firstThreeDigits, values.lastFourDigits);
    finalForm.dob = formatDate(values.month, values.day, values.year);
    onSubmit({ values: finalForm, path: '/pharmacist/replace/finish' });
  };

  let gtmTrackId = '';
  switch (props.environment) {
    case 'alunbrig':
      gtmTrackId = 'gtm-track-90';
      break;
    case 'fruzaqla':
      gtmTrackId = 'gtm-track-115';
      break;
    case 'iclusig':
      gtmTrackId = 'gtm-track-91';
      break;
    case 'ninlaro':
      gtmTrackId = 'gtm-track-92';
      break;
    default:
      gtmTrackId = '';
  }

  return (
    <div className="patient-replace form">
      <p className="required">Required field.</p>
      <form className="ui form" onSubmit={ handleSubmit(sanitizeForm) }>
        <Fields
          required
          names={ ['areaCode', 'firstThreeDigits', 'lastFourDigits'] }
          component={ renderPhone }
          errorMessage="Phone Number is a required field."
          label="Patient’s Phone number"
        />
        <Fields
          required
          names={ ['month', 'day', 'year'] }
          component={ renderDate }
          errorMessage="Date of Birth is a required field."
          label="Patient’s Date of Birth"
          customClass="date-group"
        />
        <button
          type="submit"
          className= { `ui button form-button track track-231 track-env-${props.environment} ${gtmTrackId}` }
          disabled={ invalid }
        >
          Submit
        </button>
      </form>
    </div>
  );
};

PharmaReplaceForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  environment: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'pharmaReplaceForm', // a unique identifier for this form
  validate: validateReplace, // <--- validation function given to redux-form
})(PharmaReplaceForm);
